import { render, staticRenderFns } from "./AddBasicCampaignGeneral.vue?vue&type=template&id=0560e368"
import script from "./AddBasicCampaignGeneral.vue?vue&type=script&lang=js"
export * from "./AddBasicCampaignGeneral.vue?vue&type=script&lang=js"
import style0 from "./AddBasicCampaignGeneral.vue?vue&type=style&index=0&id=0560e368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports